"use client"
import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Tab } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

import { Formik } from "formik";
import useApi from "@/components/api/useApi";
import NewFileUpload from "@/components/content/NewFileUpload";
import MaxCharacterField from "@/components/shared/MaxCharacterField";
import ReactDOM from "react-dom";
import InlineSignupForm from "@/components/login/InlineSignupForm";
import LoadingAnimation from "@/components/shared/LoadingAnimation";

let yup = require("yup");

const MediaSubmissionModal = ({ name, multiple, onSubmit, onHide, title }) => {
  const isSm = useMediaQuery({ maxWidth: "767.98px" });
  const api = useApi();

  const [authentication, setAuthentication] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [randomNumber, setRandomNumber] = useState(null);
  const [modalButtons, setModalButtons] = useState(null);

  const [deferredPayload, setDeferredPayload] = useState(null);
  const [deferredCallback, setDeferredCallback] = useState(null);
  const [filesToUpload, setFilesToUpload] = useState(null);
  const [selectedTab, setSelectedTab] = useState("media");

  useEffect(() => {
    var storedAuth = api.getAuthentication();
    if (storedAuth != null) {
      var auth = JSON.parse(storedAuth);
      setAuthentication(auth);
      var rando = api.getRandomInt(10000, 99999);
      setRandomNumber(rando);
    } else {
      // force down the road of signing up
    }
  }, []);

  useEffect(() => {
    var buttons = document.getElementById(
      `media-submission-modal-footer-${randomNumber}`
    );
    // console.log("MediaSubmissionModal buttons", buttons);
    setModalButtons(buttons);

    setLoaded(true);
  }, [randomNumber]);

  const schema = yup.object({
    caption: yup
      .string()
      .max(500)
      .label("Caption")
      .nullable()
  });

  var values = {
    assets: [],
    caption: ""
  };

  const deferredSave = (values, callback) => {
    setDeferredPayload(values);
    setDeferredCallback(callback);
    setSelectedTab("auth");
  };

  const userRegistered = ({ resourceName, passwordToken, submissionToken }) => {
    // console.log("MediaSubmissionModal userRegistered", resourceName, submissionToken);
    if (resourceName) {
      onSubmitDeferredSave(
        resourceName,
        deferredPayload,
        filesToUpload,
        submissionToken
      );
    }
  };

  const onSubmitDeferredSave = (
    newResourceName,
    values,
    files,
    submissionToken
  ) => {
    // console.log("onSubmitDeferredSave", newResourceName,values,files,submissionToken);
    // make the call to upload the files given the name
    let uploadFiles = files.map((theFile, index) => {
      return api.uploadFile(
        newResourceName,
        theFile.file,
        theFile.exif,
        submissionToken
      );
    });
    Promise.all(uploadFiles)
      .then(uploadedFiles => {
        uploadedFiles.forEach(function(asset, index) {
          if (asset.owner) {
            asset.owner = asset.owner.resourceName;
            asset.caption = values.text;
          }
        });

        values["assets"] = uploadedFiles;
        values["external"] = true;
        values["ownerResourceName"] = newResourceName;

        // console.log("CALLING ONSUBMIT", values, deferredCallback, submissionToken );

        onSubmit(values, deferredCallback, submissionToken);
      })
      .catch(error => {
        window.flash_messages.addMessage({
          id: "id",
          text: "Something went wrong submitting your content.",
          type: "error"
        });
      });
  };

  const prepareForSubmission = (values, callback) => {
    values.assets.forEach((asset, index) => {
      asset.caption = values.caption;
    });
    const payload = {
      ownerResourceName: authentication ? authentication.profileName : null,
      assets: values.assets,
      text: values.caption,
      external: authentication ? false : true
    };

    if (!authentication) {
      deferredSave(payload, callback);
    } else {
      onSubmit(payload, callback);
    }
  };

  return (
    <Modal show={true} size="lg" fullscreen={isSm} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title ?? "Contribute Media"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tab.Container activeKey={selectedTab}>
          <Tab.Content>
            <Tab.Pane eventKey="media">
              {loaded && (
                <Formik
                  initialValues={values}
                  enableReinitialize={true}
                  validationSchema={schema}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      prepareForSubmission(values, success => {
                        setSubmitting(!success);
                      });
                    }, 400);
                  }}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    isSubmitting,
                    values,
                    touched,
                    isValid,
                    errors,
                    setFieldValue
                  }) => (
                    <Form
                      id={`media-submission-form-${randomNumber}`}
                      className="styled"
                      noValidate
                      onSubmit={handleSubmit}
                    >
                      <div className="form-group" id="validationFormikMedia">
                        <NewFileUpload
                          show={true}
                          name={
                            authentication ? authentication.profileName : null
                          }
                          deferred={!authentication}
                          multiple={multiple}
                          onSelect={(assets, files) => {
                            // console.log("MapPointForm onSelect", assets, files);
                            if (files) {
                              setFilesToUpload(files);
                            }
                            setFieldValue("assets", assets);
                          }}
                          selectedAssets={values.assets}
                          selectOnUpload={true}
                          filterEnabled={authentication != null}
                          upload={true}
                          types={["IMAGE"]}
                        />
                      </div>

                      <div className="form-group" id="validationFormikCaption">
                        <MaxCharacterField
                          title="Caption"
                          schema={schema}
                          value={values.caption}
                          fieldName="caption"
                          as="textarea"
                          rows={3}
                          onChange={handleChange}
                          isInvalid={!!errors.caption && touched.caption}
                          onBlur={handleBlur}
                          placeholder="Write a caption for your contribution (optional)"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.caption}
                        </Form.Control.Feedback>
                      </div>
                      {modalButtons && (
                        <>
                          {ReactDOM.createPortal(
                            <>
                              <Button
                                form={`media-submission-form-${randomNumber}`}
                                type="submit"
                                disabled={!isValid || isSubmitting}
                                className="btn btn-primary"
                              >
                                {authentication ? "Submit" : "Next Step"}
                              </Button>
                              <button
                                type="button"
                                className="btn btn-cancel"
                                onClick={onHide}
                              >
                                Cancel
                              </button>
                            </>,
                            modalButtons
                          )}
                        </>
                      )}
                    </Form>
                  )}
                </Formik>
              )}
            </Tab.Pane>
            {!authentication && (
              <Tab.Pane eventKey="auth">
                <InlineSignupForm
                  name={name}
                  showHeading={true}
                  heading="Please create an account."
                  text="In order to submit your contribution, please provide the following information to create your account. We'll send you an activation link to your email address."
                  type="AMBASSADOR"
                  onRegistrationComplete={userRegistered}
                  overrideApproveComponent={<LoadingAnimation />}
                />
              </Tab.Pane>
            )}
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>

      <Modal.Footer
        style={{ display: selectedTab === "media" ? "flex" : "none" }}
        id={`media-submission-modal-footer-${randomNumber}`}
      ></Modal.Footer>
    </Modal>
  );
};
export default MediaSubmissionModal;
